import React from 'react';
import { getLanguageObj, settings } from '../../helpers/UtilsHelper';
import Menu from '../main/Menu';
import { GlobalFormats } from '../../classes/main/globalFormatClass';

const currentMethod = 'NotFound - function';

const { app, icons, images, labels, messages } = settings;
const { urls } = app?.backend;

export default function NotFound({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
} = {}) {

    return (
        <div>
            <Menu viewName={'home'} process={''} />

            <div className='content-wrapper bg-transparent'>

                {/* Content Header (Page header) - Premium Bar Rule 6.6 */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2 align-items-center bg-white p-3 rounded shadow-lg mx-0'>
                            <div className='col-12 col-sm-6'>
                                <h4 className='m-0 font-weight-bold text-dark'>
                                    {messages?.pageNotFound?.[languageObj?.id]}
                                </h4>
                            </div>
                            <div className='col-12 col-sm-6'>
                                <ol className='breadcrumb float-sm-right bg-transparent mb-0'>
                                    <li className='breadcrumb-item'><a href={urls?.home}>{labels?.home?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item active text-primary'>{messages?.pageNotFound?.[languageObj?.id]}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Main content - Rule 10 Grid Wrapper (Standard Width) */}
                <section className='content'>
                    <div className='container-fluid'>
                        <div className='row'>
                            <div className='col-12'>
                                {/* Premium Card using 'Roles' style pattern */}
                                <div className='card border-0 shadow-lg login-card mb-5'>

                                    {/* Card Header with circular icon pattern */}
                                    <div className='card-header bg-white border-bottom-0 pt-4 px-4'>
                                        <div className='d-flex align-items-center'>
                                            <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                                style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                <img alt='imgNotFound'
                                                    style={{ width: '25px', height: '25px', objectFit: 'contain' }}
                                                    src={images?.icons?.error404} />
                                            </div>
                                            <div className='d-flex flex-column'>
                                                <h5 className='mb-0 font-weight-bold text-dark'>
                                                    {messages?.pageNotFound?.[languageObj?.id]}
                                                </h5>
                                                <div className='mt-1'>
                                                    <span className='badge badge-pill badge-warning px-2 py-1 text-uppercase'
                                                        style={settings?.html?.badges?.micro}>
                                                        <i className={`${icons?.fasFa?.exclamationTriangle} mr-1`}></i> 404
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Card Body - Centered content for error visualization */}
                                    <div className='card-body text-center p-5'>
                                        <div className='display-4 font-weight-bold text-warning mb-4'>
                                            404
                                        </div>

                                        <h3 className='font-weight-bold text-dark mb-3'>
                                            Oops! {messages?.pageNotFound?.[languageObj?.id]}
                                        </h3>

                                        <p className='text-muted mb-5'>
                                            {messages?.weCouldNotFindThePageYouWereLookingFor?.[languageObj?.id]}.
                                        </p>

                                        {/* Action Button - Rule 3 */}
                                        <div className='d-flex justify-content-center'>
                                            <a
                                                data-title={labels?.home?.[languageObj?.id]}
                                                href={urls?.home}
                                                className='btn btn-primary shadow-sm font-weight-bold px-4 py-2 btn-primary'
                                            >
                                                <i className={`${icons?.fasFa?.home} mr-2`}></i>
                                                {labels?.home?.[languageObj?.id]}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    )
}